import { DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material';
import { useRaffleDrawContext } from '../provider';
import Description from './mail-description';
import Settings from './mail-settings';
import CreateMailProvider, { useCreateContext } from './provider';
import { BootstrapDialog, StyledActionContainer, StyledButtonCancel, StyledButtonSave } from './styles.css';

function CreateDialog() {

  return (
    <CreateMailProvider>
      <Component />
    </CreateMailProvider>
  );
}


function Component() {
  const { state: STATE, openCreate } = useRaffleDrawContext();
  const { isLoading, onCreating } = useCreateContext();

  return (
    <BootstrapDialog
      fullWidth
      open={STATE.openCreate}
      onClose={openCreate} >
      <DialogTitle sx={{ m: 0, px: 4, pt: 3, borderBottom: 1, borderBottomColor: "#F1F5F9" }}>
        {"NEW RAFFLE DRAW FORM"}
      </DialogTitle>
      <DialogContent>
        <Stack>
          <Description />
          <Settings />
        </Stack>
      </DialogContent>
      <DialogActions>
        <StyledActionContainer>
          <StyledButtonCancel variant='outlined' onClick={openCreate} >CANCEL</StyledButtonCancel>
          <StyledButtonSave
            variant="contained"
            form="game-details-form"
            type="submit"
            loading={isLoading}
            onClick={onCreating}
          >
            SAVE
          </StyledButtonSave>
        </StyledActionContainer>
      </DialogActions>
    </BootstrapDialog>
  );
}

export default CreateDialog;